import FORM_CONTEXT_PHYSICAL_WORLD from '../forms-context.enum'

const FORM_RECEIVERS = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_RECEIVERS,
  disabled: true,
  initialValues: {}
}

const FORM_TERMINAL_DATA = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_TERMINAL_DATA,
  disabled: true,
  initialValues: {}
}

const FORM_ADDRESS = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_ADDRESS,
  searchZipCode: false,
  disabled: true,
  initialValues: {}
}

const FORM_OBSERVATION = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_OBSERVATION,
  disabled: true,
  initialValues: {}
}

const FORM_OPEN_HOURS = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_OPEN_HOURS,
  disabled: true,
  initialValues: {}
}

export {
  FORM_RECEIVERS,
  FORM_TERMINAL_DATA,
  FORM_ADDRESS,
  FORM_OBSERVATION,
  FORM_OPEN_HOURS
}
